import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="dialog"
export default class extends Controller {
  static values = {
    open: Boolean,
    closeOnEscape: { type: Boolean, default: true },
  };

  connect() {
    this.allowClose = false;
    this.boundPreventCancel = this.preventCancel.bind(this);
    this.boundPreventEscape = this.preventEscape.bind(this);
    this.boundPreventUnintentionalClose = this.preventUnintentionalClose.bind(this);

    if (!this.closeOnEscapeValue) {
      this.element.addEventListener("cancel", this.boundPreventCancel);
      this.element.addEventListener("close", this.boundPreventUnintentionalClose);
      document.addEventListener("keydown", this.boundPreventEscape, true);
    }

    this.openValueChanged();
  }

  disconnect() {
    if (!this.closeOnEscapeValue) {
      this.element.removeEventListener("cancel", this.boundPreventCancel);
      this.element.removeEventListener("close", this.boundPreventUnintentionalClose);
      document.removeEventListener("keydown", this.boundPreventEscape, true);
    }
  }

  preventCancel(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  preventEscape(event) {
    if (event.key !== "Escape") return;
    if (!this.isActiveDialog()) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  preventUnintentionalClose() {
    if (this.closeOnEscapeValue || this.allowClose) {
      this.allowClose = false;
      return;
    }

    this.element.showModal();
  }

  isActiveDialog() {
    if (!this.element.open) return false;

    const openDialogs = document.querySelectorAll("dialog[open]");
    return openDialogs[openDialogs.length - 1] === this.element;
  }

  closeElement() {
    this.allowClose = true;
    this.element.close();
  }

  openValueChanged() {
    if (this.openValue) {
      this.element.showModal();
      this.dispatch("open");
    } else {
      this.closeElement();
      this.dispatch("close");
    }
  }

  close() {
    this.openValue = false;
  }

  open() {
    this.openValue = true;
    this.element.showModal();
    this.dispatch("open");
  }

  // Hide dialog on successful form submission
  // data-action="turbo:submit-end->dialog#closeOnSuccess"
  closeOnSuccess(e) {
    if (e.detail.success) {
      this.openValue = false;
    }
  }
}
